<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{getHeaderDictionaryKey() | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content>
      <div class="row mx-0 my-1">
        <div class="col-md-6 p-0" *ngFor="let tr of taskRecords">
          <app-task-record-table-cell
            [taskRecord]="tr"
            (taskRecordClicked)="onTaskRecordSelected(tr)"
            [borderEnabled]="true">
          </app-task-record-table-cell>
        </div>
      </div>
    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog()">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
  </div>
</div>
